import Component from '@glimmer/component';
import _ from 'lodash';
import { eachDayOfInterval, isSameDay, isPast, isFuture } from 'date-fns';
import { action } from '@ember/object';
export default class DeluxePlayerScheduleHeaderComponent extends Component {

  dateClass(date) {
    if (isSameDay(date, new Date())) {
      return 'today';
    } else if (isFuture(date)) {
      return 'future';
    } else if (isPast(date)) {
      return 'past';
    }
  }

  get scrollPercentage() {
    if (this.args.selectedDate) {
      let index = _.findIndex(
        this.args.dateObjects,
        (d) => d.id == this.args.selectedDate.id,
      );

      let chosenIndex = Math.min(this.args.dateObjects.length - 1, index - 4);
      // console.log(`index = ${index} / ${this.args.dates.length - 1}`)
      let percent = chosenIndex / (this.args.dateObjects.length - 1);
      return percent;
    } else {
      return 0;
    }
  }

  @action
  scrollToDay(element) {
    element.scrollIntoView();
  }
}
